import { Link } from "react-router-dom";
import { useSettings } from "@/hooks/useSettings";
import { renderInlineLinks } from "@/lib/inline";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-8">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-t border-black py-12 grid grid-cols-2 md:grid-cols-[1fr_1fr_auto] gap-8 md:items-start">
        <div className="col-span-2 md:col-span-1">
          <h3 className="serif text-sm text-black tracking-tight">What Do We Want? <span className="italic" style={{ color: "#fc4707" }}>When Do We Want It?</span></h3>
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mt-4">The Objective</div>
          <p className="text-sm text-neutral-600 mt-3 leading-relaxed max-w-sm">
            {renderInlineLinks(settings.footer_copy)}
          </p>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Sections</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="/leaders" className="edi-link">Leaders</a></li>
            <li><a href="/editorials" className="edi-link">Editorials</a></li>
            <li><a href="/debates" className="edi-link">Debates</a></li>
            <li><a href="/interviews" className="edi-link">Interviews</a></li>
            <li><a href="/polls" className="edi-link">Polls</a></li>
            <li><a href="/about" className="edi-link">About</a></li>
          </ul>
        </div>
        <div className="justify-self-end self-center md:justify-self-end md:self-center">
          <Link to="/" data-testid="footer-logo-link" aria-label="Back to home">
            <img
              src="/logo.png"
              alt="What Do We Want? When Do We Want It?"
              data-testid="footer-logo"
              className="h-[7.5rem] w-auto select-none"
              draggable="false"
            />
          </Link>
        </div>
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4 border-t border-black flex flex-col sm:flex-row justify-between mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
          <span>&copy; {new Date().getFullYear()} &nbsp; David Clegg</span>
          <a
            href="mailto:whatdowewant@gmx.co.uk"
            data-testid="footer-email-link"
            className="hover:text-black transition-colors"
          >
            Email: whatdowewant@gmx.co.uk
          </a>
        </div>
      </div>
    </footer>
  );
}
